/**
 * Sample artwork for each kind of event on the customer's planning screen.
 *
 * <p>Drawn here rather than uploaded, so the screen never waits on a picture
 * and nothing needs hosting. Replace any of them with a photograph later by
 * giving the card its own image.</p>
 */

const frame = (body: string) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 140" preserveAspectRatio="xMidYMid slice">${body}</svg>`,
  )}`

const ART: Record<string, string> = {
  // A banquet hall: a chandelier over laid tables.
  BANQUET: frame(
    '<rect width="320" height="140" fill="#f6ebe3"/>' +
      '<path d="M0 100 L320 100 L320 140 L0 140Z" fill="#e8d2c4"/>' +
      '<line x1="160" y1="0" x2="160" y2="30" stroke="#7a2030" stroke-width="2"/>' +
      '<circle cx="160" cy="38" r="12" fill="#c9a24a"/><circle cx="160" cy="38" r="22" fill="#c9a24a" opacity=".2"/>' +
      '<rect x="40" y="92" width="110" height="10" rx="3" fill="#7a2030"/>' +
      '<rect x="170" y="92" width="110" height="10" rx="3" fill="#7a2030"/>' +
      '<circle cx="70" cy="86" r="6" fill="#fff"/><circle cx="100" cy="86" r="6" fill="#fff"/><circle cx="220" cy="86" r="6" fill="#fff"/><circle cx="250" cy="86" r="6" fill="#fff"/>',
  ),
  // A restaurant table: plates, a glass, and a cup.
  RESTAURANT_PARTY: frame(
    '<rect width="320" height="140" fill="#fbf1e6"/>' +
      '<rect x="0" y="108" width="320" height="32" fill="#e7cfb8"/>' +
      '<circle cx="110" cy="80" r="34" fill="#ffffff" stroke="#c9a24a" stroke-width="4"/>' +
      '<circle cx="110" cy="80" r="20" fill="#f3d9a4"/>' +
      '<circle cx="210" cy="80" r="34" fill="#ffffff" stroke="#c9a24a" stroke-width="4"/>' +
      '<circle cx="210" cy="80" r="20" fill="#e8b4a0"/>' +
      '<rect x="262" y="48" width="14" height="36" rx="5" fill="#9fc7d8" opacity=".8"/>',
  ),
  // Outdoor catering: a marquee on poles with a buffet line.
  OUTDOOR_CATERING: frame(
    '<rect width="320" height="140" fill="#eef4ea"/>' +
      '<path d="M40 60 L160 18 L280 60 L280 110 L40 110Z" fill="#ffffff" stroke="#7a2030" stroke-width="3"/>' +
      '<path d="M40 60 L80 60 L80 110 M120 60 L120 110 M200 60 L200 110 M240 60 L240 110" fill="none" stroke="#7a2030" stroke-width="3" opacity=".6"/>' +
      '<rect x="60" y="100" width="200" height="12" rx="3" fill="#c9a24a"/>' +
      '<circle cx="90" cy="96" r="5" fill="#7a2030"/><circle cx="150" cy="96" r="5" fill="#7a2030"/><circle cx="210" cy="96" r="5" fill="#7a2030"/>',
  ),
  // Bulk takeaway: stacked boxes and a bag.
  BULK_TAKEAWAY: frame(
    '<rect width="320" height="140" fill="#fbf3e8"/>' +
      '<rect x="60" y="72" width="70" height="46" rx="4" fill="#d9a86c"/>' +
      '<rect x="70" y="50" width="70" height="46" rx="4" fill="#e7bd86"/>' +
      '<rect x="190" y="82" width="64" height="36" rx="4" fill="#7a2030"/>' +
      '<path d="M200 82 Q222 62 244 82" fill="none" stroke="#7a2030" stroke-width="4"/>',
  ),
  // Sweets and snacks: laddus on a plate, with a cup of coffee.
  COUNTER_SALE: frame(
    '<rect width="320" height="140" fill="#fdf4e6"/>' +
      '<ellipse cx="160" cy="104" rx="90" ry="16" fill="#f0d9b5"/>' +
      '<circle cx="120" cy="90" r="16" fill="#e0a13a"/><circle cx="146" cy="84" r="16" fill="#f0c25a"/>' +
      '<circle cx="174" cy="90" r="16" fill="#c97a2b"/><circle cx="200" cy="84" r="14" fill="#e0a13a"/>' +
      '<rect x="234" y="70" width="34" height="34" rx="6" fill="#7a2030"/>' +
      '<path d="M268 78 Q284 78 282 92 Q280 102 268 100" fill="none" stroke="#7a2030" stroke-width="4"/>',
  ),
}

/** The artwork for one kind of event, or nothing for a kind not yet drawn. */
export function serviceArt(code: string): string | undefined {
  return ART[code]
}

/** On the customer's screen, Counter sale is what the shop calls its sweets and snacks. */
export function customerServiceName(code: string, name: string): string {
  return code === 'COUNTER_SALE' ? 'Sweets and Snacks' : name
}

export function customerServiceNote(code: string, fallback: string): string {
  return code === 'COUNTER_SALE' ? 'Sweets, snacks and coffee from our counter' : fallback
}
